<div class="graph-card">

  <div class="graph-header">
    {{ title }}
     <span *ngIf="state" class="graph-state">
      - [
      <span [ngClass]="{
          'state-safe': state === 'Safe',
          'state-warning': state === 'Warning',
          'state-recovery': state === 'Recovering'
        }">
        State={{ state }}
      </span>
      ]
    </span>
  </div>

  <div class="graph-separator"></div>

  <canvas #canvas width="700"></canvas>

</div>
